import React, { Component } from 'react';
import { Theme } from '../Theme';

export interface ButtonProps {
    label: string;
    icon?: string; // Path to the icon image
    type: 'primary' | 'secondary';
    onClick?: () => void;
    disabled?: boolean;
    style?: React.CSSProperties;
    htmlType?: 'button' | 'submit' | 'reset';
}

interface ButtonState {
    isPressed: boolean;
}

export class Button extends Component<ButtonProps, ButtonState> {
    constructor(props: ButtonProps) {
        super(props);
        this.state = {
            isPressed: false
        };
    }
    private getButtonStyle = (): React.CSSProperties => {
        const { type, disabled } = this.props;
        const { isPressed } = this.state;
        
        let opacity = 1;
        if (disabled) {
            opacity = 0.5;
        } 
        else if (isPressed) {
            opacity = 0.3;
        }
        
        const baseStyle: React.CSSProperties = {
            padding: '8px 16px',
            borderRadius: '6px',
            height: '42px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            border: Theme.Colours.border,
            opacity: opacity,
            transition: 'opacity 0.1s ease',
        };

        if (type === 'primary') {
            return {
                ...baseStyle,
                backgroundColor: Theme.Colours.buttonBackground,
                color: Theme.Colours.buttonText,
            };
        } 
        else {
            return {
                ...baseStyle,
                backgroundColor: Theme.Colours.workArea,
                color: Theme.Colours.text,
            };
        }
    };

    private handleClick = () => {
        const { onClick, disabled } = this.props;
        if (!disabled && onClick) {
            onClick();
        }
    };

    private handleMouseDown = () => {
        const { disabled } = this.props;
        if (!disabled) {
            this.setState({ isPressed: true });
        }
    };

    private handleMouseUp = () => {
        this.setState({ isPressed: false });
    };

    private handleMouseLeave = () => {
        this.setState({ isPressed: false });
    };

    public render(): React.ReactNode {
        const { label, icon, style, disabled, htmlType = 'button' } = this.props;
        const buttonStyle = { ...this.getButtonStyle(), ...style };

        return (
            <button
                onClick={this.handleClick}
                onMouseDown={this.handleMouseDown}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseLeave}
                style={buttonStyle}
                type={htmlType}
                disabled={disabled}
            >
                {icon && (
                    <img 
                        src={icon} 
                        alt='icon' 
                        style={styles.icon}
                    />
                )}
                {label}
            </button>
        );
    }
}

const styles = {
    icon: {
        width: '16px',
        height: '16px',
    },
};
